import { useEffect, useState } from "react";

const EVENTS = [
  { time: "6:42 AM", label: "Show-Up Card opened", detail: "742 Elm St · Apt 2B" },
  { time: "6:58 AM", label: "Vendor bill auto-matched", detail: "$487 → LCV Contracting" },
  { time: "7:03 AM", label: "Camera moved", detail: "FLOAT-1 → 88 Oakhurst Ave" },
  { time: "7:14 AM", label: "Move-in tile flipped", detail: "1200 Maple Ave · 3A" },
  { time: "7:31 AM", label: "Voice-note transcribed", detail: "P-trap replaced under kitchen sink" },
  { time: "7:44 AM", label: "Photo gate passed", detail: "before + after · WO #4712" },
  { time: "8:02 AM", label: "Portfolio Health", detail: "87 · +5 pts this week" },
  { time: "8:16 AM", label: "Backlog cleared", detail: "12 stale WOs bulk-closed" },
  { time: "8:29 AM", label: "Nearby bundler saved", detail: "3 WOs knocked out in one stop" },
  { time: "8:47 AM", label: "Truck stock synced", detail: "24 items across 3 vans" },
];

/**
 * Live Radar Ticker — landing-page hero animation.
 * Rotates through anonymized events every ~4s to prove the app is alive.
 * All addresses are fabricated for privacy.
 */
export default function LiveRadarTicker() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % EVENTS.length), 4000);
    return () => clearInterval(t);
  }, []);
  const e = EVENTS[idx];
  return (
    <div className="inline-flex items-center gap-3 h-10 pl-3 pr-4 border-2 border-slate-900 bg-white shadow-[3px_3px_0_#0b1220] max-w-full overflow-hidden"
      data-testid="landing-live-ticker">
      <span className="inline-flex items-center gap-1.5 text-[10px] font-black uppercase tracking-widest text-red-600 flex-shrink-0">
        <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span> LIVE
      </span>
      <span className="font-mono font-black text-slate-500 text-xs flex-shrink-0">{e.time}</span>
      <span className="text-[11px] font-black uppercase tracking-widest text-slate-900 truncate">{e.label}</span>
      <span className="text-[11px] text-slate-500 truncate hidden sm:inline">· {e.detail}</span>
    </div>
  );
}
